const HEADING_PREFIX = 'heading';
const PAGE_NUMBER_PREFIX = 'pgnum';

// TODO
function isPage(page) {
  return page.id.indexOf('table-of-contents') >= 0;
}

// TODO
function isFirstPage(page, pages = []) {
  if (!isPage(page)) {
    return false;
  }

  const tocPages = pages.filter(isPage);

  if (tocPages.length === 0) {
    return false;
  }

  return tocPages[0].key === page.key;
}

function isCaptionPlaceholder(placeholder) {
  if (placeholder.type !== 'text') {
    return false;
  }

  return placeholder.id === 'page-caption';
}

function isHeadingPlaceholder(placeholder) {
  if (placeholder.type !== 'text') {
    return false;
  }

  if (placeholder.id.indexOf(`${HEADING_PREFIX}-`) !== 0) {
    return false;
  }

  const index = placeholder.id.replace(`${HEADING_PREFIX}-`, '');

  return index.match(/^[0-9]+$/);
}

function isPageNumberPlaceholder(placeholder) {
  if (placeholder.type !== 'text') {
    return false;
  }

  if (placeholder.id.indexOf(`${PAGE_NUMBER_PREFIX}-`) !== 0) {
    return false;
  }

  const index = placeholder.id.replace(`${PAGE_NUMBER_PREFIX}-`, '');

  return index.match(/^[0-9]+$/);
}

function getHeadingIndex(placeholder) {
  return parseInt(placeholder.id.replace(`${HEADING_PREFIX}-`, ''), 10);
}

function getPageNumberIndex(placeholder) {
  return parseInt(placeholder.id.replace(`${PAGE_NUMBER_PREFIX}-`, ''), 10);
}

function getHeadingPlaceholderId(index) {
  return `${HEADING_PREFIX}-${index}`;
}

function getPageNumberPlaceholderId(index) {
  return `${PAGE_NUMBER_PREFIX}-${index}`;
}

export default {
  isPage,
  isFirstPage,
  isCaptionPlaceholder,
  isHeadingPlaceholder,
  isPageNumberPlaceholder,
  getHeadingIndex,
  getPageNumberIndex,
  getHeadingPlaceholderId,
  getPageNumberPlaceholderId,
};
